module.exports = __webpack_public_path__ + "img/ivTest_sub67.e0801350.png";